var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c(
          "div",
          {
            staticClass:
              "pt-3 l-m-b-20 align-items-center d-flex justify-content-between"
          },
          [
            _c("div", { staticClass: "col-8 d-flex align-items-center" }, [
              _c("h1", { staticClass: "pr-3" }, [_vm._v("Leads")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group search" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn input-group-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.clearSearch }
                  },
                  [
                    _c("i", {
                      class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                    })
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.q,
                      expression: "q"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Search" },
                  domProps: { value: _vm.q },
                  on: {
                    keydown: function($event) {
                      _vm.searchText($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.q = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-2" },
              [
                _c("load-filter-dropdown", {
                  attrs: { route: _vm.$route.name },
                  on: {
                    filterSelected: _vm.loadFilters,
                    filterTemplatesInitialized:
                      _vm.setFilterTemplatesInitialized
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-2 text-right d-none d-md-flex d-lg-flex d-xl-flex"
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        _vm.showCreateSidebar = !_vm.showCreateSidebar
                      }
                    }
                  },
                  [_vm._v("\n          ADD LEAD\n        ")]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between align-items-center d-md-none"
          },
          [
            _vm.meta
              ? _c("div", { staticClass: "number-of-jobs" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.meta.to) +
                      " of " +
                      _vm._s(_vm.meta.total) +
                      " "
                  ),
                  _c("span", { staticClass: "us-hidden" }, [_vm._v("Leads")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 text-right pr-0 d-flex align-items-center mobile-lead-menu"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          _vm.showCreateSidebar = !_vm.showCreateSidebar
                        }
                      }
                    },
                    [_vm._v("\n            ADD LEAD\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary expand-all",
                      on: { click: _vm.toggleAllLeads }
                    },
                    [
                      _c("i", {
                        class: [
                          _vm.leads && _vm.expandedAll
                            ? "fa fa-compress"
                            : "fa fa-expand"
                        ]
                      })
                    ]
                  )
                ]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row d-none d-md-flex d-lg-flex d-xl-flex" }, [
          _c("div", { staticClass: "col-11 filters-field" }, [
            _c("span", [_vm._v("Filters:")]),
            _vm._v(" "),
            _vm.filtersLoaded
              ? _c("span", [
                  _vm.filters.company.length && _vm.companies
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.company, function(company) {
                          return _c(
                            "span",
                            {
                              key: company,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("company", company)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Company: " +
                                  _vm._s(
                                    _vm.companies.find(function(el) {
                                      return el.id === company
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.clusterUser.length && _vm.salesFilter.length
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.clusterUser, function(clusterUser) {
                          return _c(
                            "span",
                            {
                              key: clusterUser,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("clusterUser", clusterUser)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Sales: " +
                                  _vm._s(
                                    _vm.salesFilter.find(function(el) {
                                      return el.id === clusterUser
                                    }).full_name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.moveSize
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("moveSize")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Move Size: " +
                              _vm._s(
                                _vm.moveSizes.find(function(el) {
                                  return el.id === _vm.filters.moveSize
                                }).name
                              )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.move_date
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("move_date")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Move Date: " +
                              _vm._s(_vm.filters.move_date)
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.created_at
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("created_at")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Created At: " +
                              _vm._s(_vm.filters.created_at)
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.status
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("status")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Status: " +
                              _vm._s(
                                _vm.leadStatuses.find(function(el) {
                                  return el.id === _vm.filters.status
                                }).name
                              )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.source
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("source")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Source: " +
                              _vm._s(
                                _vm.sources.find(function(el) {
                                  return el.id === _vm.filters.source
                                }).name
                              )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.closed
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("closed")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Show Closed: " +
                              _vm._s(
                                _vm.filters.closed === "true" ? "Yes" : "No"
                              )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.feeChange
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("feeChange")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Fee Changes Required: " +
                              _vm._s(
                                _vm.filters.feeChange === "true" ? "Yes" : "No"
                              )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.hasHeavyItems
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("hasHeavyItems")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Has heavy items: " +
                              _vm._s(
                                _vm.filters.hasHeavyItems === "true"
                                  ? "Yes"
                                  : "No"
                              )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.offers_sent
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("offers_sent")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Offers Sent: " +
                              _vm._s(
                                _vm.filters.offers_sent === "true"
                                  ? "Yes"
                                  : "No"
                              )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.tags.length && _vm.tags
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.tags, function(item) {
                          return _c(
                            "span",
                            {
                              key: item,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("tags", item)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Tag: " +
                                  _vm._s(
                                    _vm.tags.find(function(el) {
                                      return el.id === item
                                    }).name
                                  ) +
                                  " "
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.withoutFollowup.length && _vm.leadFollowUpTypes
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.withoutFollowup, function(item) {
                          return _c(
                            "span",
                            {
                              key: item,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("withoutFollowup", item)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Without followup: " +
                                  _vm._s(
                                    _vm.leadFollowUpTypes.find(function(el) {
                                      return el.id === item
                                    }).name
                                  ) +
                                  " "
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary add-filters",
                on: {
                  click: function($event) {
                    _vm.showFilters = true
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-plus filter-icon" })]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-1 d-flex justify-content-end" }, [
            _c("div", { staticClass: "dropdown" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-secondary sort-button sort-button-selected",
                  attrs: {
                    id: "dropdownMenuButton",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _vm.selectedKey.length
                    ? _c("i", {
                        staticClass: "fa pr-2",
                        class: [
                          _vm.ascOrDesc === "asc"
                            ? "fa-sort-amount-asc"
                            : "fa-sort-amount-desc"
                        ]
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedKey === "created_at"
                    ? _c("span", [
                        _vm._v("\n              Created at\n            ")
                      ])
                    : _vm.selectedKey === "move_date"
                      ? _c("span", [
                          _vm._v("\n              Move date\n            ")
                        ])
                      : _c("span", [
                          _vm._v("\n              Sort by\n            ")
                        ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-caret-down caret" })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu sort-dropdown dropdown-menu-right",
                  attrs: { "aria-labelledby": "dropdownMenuButton" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "dropdown-item sort-dropdown-item nav-link btn",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.sortBy("created_at")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class: [
                            _vm.selectedKey === "created_at" ? "selected" : ""
                          ]
                        },
                        [
                          _vm._v(
                            "\n                Created date\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm.selectedKey === "created_at"
                          ? _c("i", {
                              staticClass: "fa",
                              class: [
                                _vm.ascOrDesc === "asc"
                                  ? "fa-sort-amount-asc"
                                  : "fa-sort-amount-desc"
                              ]
                            })
                          : _vm._e()
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "dropdown-item sort-dropdown-item nav-link btn",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.sortBy("move_date")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class: [
                            _vm.selectedKey === "move_date" ? "selected" : ""
                          ]
                        },
                        [_vm._v("\n                Move date\n              ")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm.selectedKey === "move_date"
                          ? _c("i", {
                              staticClass: "fa",
                              class: [
                                _vm.ascOrDesc === "asc"
                                  ? "fa-sort-amount-asc"
                                  : "fa-sort-amount-desc"
                              ]
                            })
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary expand-all",
                on: { click: _vm.toggleAllLeads }
              },
              [
                _c("i", {
                  class: [
                    _vm.leads && _vm.expandedAll
                      ? "fa fa-compress"
                      : "fa fa-expand"
                  ]
                })
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.leads
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "blocks" },
              _vm._l(_vm.leads, function(lead, index) {
                return _c("LeadsBlock", {
                  key: index,
                  attrs: { lead: lead, q: _vm.q, expanded: _vm.expanded },
                  on: {
                    "update:lead": function($event) {
                      lead = $event
                    },
                    "update:q": function($event) {
                      _vm.q = $event
                    },
                    expanded: _vm.toggleLead,
                    setFiltersSaved: _vm.callSetFiltersSaved
                  }
                })
              })
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row blocks" },
              [
                _vm.meta.total
                  ? _c(
                      "div",
                      { staticClass: "col-sm-6 mb-1 pl-0 text-black-50" },
                      [
                        _vm._v(
                          "\n        Showing " +
                            _vm._s(_vm.meta.from) +
                            " - " +
                            _vm._s(_vm.meta.to) +
                            " of " +
                            _vm._s(_vm.meta.total) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1 pr-0",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "filters-side-modal flex flex-column justify-content-between"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            _vm.showFilters = !_vm.showFilters
                          }
                        }
                      },
                      [
                        _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                          _c("span", { staticClass: "btn btn-back" }),
                          _vm._v("Add Filter")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _c("p", [
                        _vm._v(
                          "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "l-bg-white" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("div", { staticClass: "row filters" }, [
                            _vm.companies && _vm.companies.length
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Company")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.companies,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "close-on-select": false,
                                          "hide-selected": true,
                                          id: "company-select",
                                          placeholder: "Select Company",
                                          "preserve-search": false,
                                          label: "name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.company,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "company",
                                              $$v
                                            )
                                          },
                                          expression: "filters.company"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Move Size")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      "input-id": "move-size-select",
                                      options: _vm.moveSizes,
                                      placeholder: "Select Move Size"
                                    },
                                    on: { input: _vm.search },
                                    model: {
                                      value: _vm.filters.moveSize,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "moveSize", $$v)
                                      },
                                      expression: "filters.moveSize"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Move date")]),
                                  _vm._v(" "),
                                  _c("flat-pickr", {
                                    staticClass: "simple-select-input",
                                    attrs: {
                                      config: _vm.config,
                                      placeholder: "Select Move Date",
                                      name: "date"
                                    },
                                    on: { "on-close": _vm.onMoveDateChange },
                                    model: {
                                      value: _vm.filters.move_date,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "move_date", $$v)
                                      },
                                      expression: "filters.move_date"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.filters.move_date
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "position-absolute clear-date",
                                          on: {
                                            click: _vm.clearMoveDateAndSearch
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-clear"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "sr-only",
                                              attrs: { "aria-hidden": "true" }
                                            },
                                            [_vm._v("Clear")]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "position-absolute clear-date clear-date-transparent"
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-rates-dark"
                                          })
                                        ]
                                      )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Created At")]),
                                  _vm._v(" "),
                                  _c("flat-pickr", {
                                    staticClass: "simple-select-input",
                                    attrs: {
                                      config: _vm.config,
                                      placeholder: "Select Created Date",
                                      name: "date"
                                    },
                                    on: { "on-close": _vm.onCreatedDateChange },
                                    model: {
                                      value: _vm.filters.created_at,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "created_at", $$v)
                                      },
                                      expression: "filters.created_at"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.filters.created_at
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "position-absolute clear-date",
                                          on: {
                                            click: _vm.clearCreatedDateAndSearch
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-clear"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "sr-only",
                                              attrs: { "aria-hidden": "true" }
                                            },
                                            [_vm._v("Clear")]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "position-absolute clear-date clear-date-transparent"
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mod-icon-rates-dark"
                                          })
                                        ]
                                      )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.salesFilter && _vm.salesFilter.length
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Sales Rep.")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.salesFilter,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "close-on-select": false,
                                          "hide-selected": true,
                                          id: "sales-select",
                                          placeholder: "Select Sales",
                                          "preserve-search": false,
                                          label: "full_name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.full_name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.clusterUser,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "clusterUser",
                                              $$v
                                            )
                                          },
                                          expression: "filters.clusterUser"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Status")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.leadStatuses,
                                      "input-id": "status-select",
                                      placeholder: "Select Status"
                                    },
                                    on: { input: _vm.search },
                                    model: {
                                      value: _vm.filters.status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "status", $$v)
                                      },
                                      expression: "filters.status"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Source")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.sources,
                                      "input-id": "source-select",
                                      placeholder: "Select Source"
                                    },
                                    on: { input: _vm.search },
                                    model: {
                                      value: _vm.filters.source,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "source", $$v)
                                      },
                                      expression: "filters.source"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Show closed")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.booleanOptions,
                                      "input-id": "closed-select",
                                      placeholder: "Select"
                                    },
                                    on: { input: _vm.search },
                                    model: {
                                      value: _vm.filters.closed,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "closed", $$v)
                                      },
                                      expression: "filters.closed"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Fee Changes Required")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.booleanOptions,
                                      "input-id": "heavy-select",
                                      placeholder: "Select"
                                    },
                                    on: { input: _vm.search },
                                    model: {
                                      value: _vm.filters.feeChange,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filters, "feeChange", $$v)
                                      },
                                      expression: "filters.feeChange"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Has heavy tems")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.booleanOptions,
                                      "input-id": "heavy-select",
                                      placeholder: "Select"
                                    },
                                    on: { input: _vm.search },
                                    model: {
                                      value: _vm.filters.hasHeavyItems,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "hasHeavyItems",
                                          $$v
                                        )
                                      },
                                      expression: "filters.hasHeavyItems"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-12" }, [
                              _c(
                                "div",
                                { staticClass: "select-wrap" },
                                [
                                  _c("label", [_vm._v("Offers sent")]),
                                  _vm._v(" "),
                                  _c("simple-select", {
                                    attrs: {
                                      options: _vm.booleanOptions,
                                      "input-id": "offers-sent-select",
                                      placeholder: "Select"
                                    },
                                    on: { input: _vm.search },
                                    model: {
                                      value: _vm.filters.offers_sent,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "offers_sent",
                                          $$v
                                        )
                                      },
                                      expression: "filters.offers_sent"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _vm.$_can("tags.show")
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Tags")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        staticClass: "w-100",
                                        attrs: {
                                          options: _vm.tags,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "close-on-select": false,
                                          "track-by": "id",
                                          label: "name"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag p-0 bg-transparent"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      [
                                                        _c("tag-color", {
                                                          attrs: {
                                                            color:
                                                              props.option.color
                                                                .name,
                                                            name:
                                                              props.option.name
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          },
                                          {
                                            key: "option",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "option__desc"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center justify-content-between"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "option__title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                              " +
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                ) +
                                                                "\n                            "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.tags,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "tags", $$v)
                                          },
                                          expression: "filters.tags"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.leadFollowUpTypes.length
                              ? _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Without followup")]),
                                      _vm._v(" "),
                                      _c("key-multiselect", {
                                        attrs: {
                                          options: _vm.leadFollowUpTypes,
                                          multiple: true,
                                          "clear-on-select": false,
                                          "close-on-select": false,
                                          "hide-selected": true,
                                          id: "follow-up-type-select",
                                          placeholder: "Select Type",
                                          "preserve-search": false,
                                          label: "name",
                                          "track-by": "id"
                                        },
                                        on: { input: _vm.search },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "tag",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "multiselect__tag"
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("span", {
                                                      staticClass:
                                                        "multiselect__tag-icon",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.remove(
                                                            props.option
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.filters.withoutFollowup,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filters,
                                              "withoutFollowup",
                                              $$v
                                            )
                                          },
                                          expression: "filters.withoutFollowup"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-auto" }, [
                      _c("div", { staticClass: "col" }, [
                        !_vm.clearFiltersButtonShouldBeDisabled
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-not-active text-dark w-100",
                                attrs: { type: "button" },
                                on: { click: _vm.clearFilters }
                              },
                              [
                                _vm._v(
                                  "\n              Clear filters\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        !_vm.clearFiltersButtonShouldBeDisabled
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary text-white w-100",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    _vm.saveFiltersModal = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Save filters\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCreateSidebar
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    return _vm.hideCreateSidebar($event)
                  }
                }
              },
              [
                _c("leads-create", {
                  staticClass: "sidebar-right",
                  attrs: {
                    "searching-duplicate-leads": _vm.searchingDuplicateLeads
                  },
                  on: {
                    cancel: _vm.hideCreateSidebar,
                    "leads-search": _vm.checkDuplicateLeads,
                    "leads-clear": _vm.clearDuplicateLeads
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.duplicateLeads.length
          ? _c("div", { staticClass: "duplicate-lead-wrap" }, [
              _c("h3", [
                _vm._v("Existing leads for the same customer have been found.")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "duplicate-lead-box-overflow" },
                [
                  _vm._l(_vm.duplicateLeads, function(lead) {
                    return _c(
                      "div",
                      {
                        key: lead.id,
                        staticClass: "duplicate-lead-box",
                        class: { "lead-can-access": lead.can_access === true }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            class: [
                              lead.can_access === true
                                ? "pointer"
                                : "pointer-events-none"
                            ],
                            attrs: {
                              to: "/leads/edit/" + lead.id + "?q=" + lead.ref_id
                            }
                          },
                          [
                            _c("div", { staticClass: "col-md-4 px-0 mb-0" }, [
                              _c("span", { staticClass: "refId" }, [
                                _vm._v(_vm._s(lead.ref_id))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-6 px-0 mb-0" }, [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(_vm._s(lead.customer))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-2 px-0 mb-0 text-right" },
                              [_c("span", { staticClass: "mod-icon-arrow" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 px-0 mb-0 pt-1" },
                              [
                                _c("div", { staticClass: "input-wrap" }, [
                                  _c("label", [_vm._v("Assigned to")]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        lead.cluster_user
                                          ? lead.cluster_user
                                          : "-"
                                      )
                                    )
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-8 px-0 mb-0 pt-2" },
                              [
                                _c("div", { staticClass: "input-wrap" }, [
                                  _c("label", [_vm._v("Company")]),
                                  _vm._v(" "),
                                  _c("p", [_vm._v(_vm._s(lead.company))])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-4 px-0 mb-0 pt-2 text-right"
                              },
                              [
                                lead.status
                                  ? [
                                      lead.status_id === 1 ||
                                      lead.status_id === 7
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-active" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      lead.status_id === 2
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-booked" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      lead.status_id === 3 ||
                                      lead.status_id === 6
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-closed" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      lead.status_id === 4 ||
                                      lead.status_id === 8
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-ncover" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      lead.status_id === 5
                                        ? _c(
                                            "span",
                                            { class: "btn-status btn-rtbook" },
                                            [_vm._v(_vm._s(lead.status.name))]
                                          )
                                        : _vm._e()
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c("error-field", {
                    attrs: { errors: _vm.errors, field: "leads" }
                  })
                ],
                2
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.saveFiltersModal
        ? _c("SaveFiltersModal", {
            attrs: { filters: _vm.filters, route: _vm.$route.path },
            on: {
              close: function($event) {
                _vm.saveFiltersModal = false
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c854f9f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c854f9f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/Leads.vue
// module id = null
// module chunks = 